export const PRIVILEGES = {
  CHANGE_CODES: 'change_codes',
  GENERATION_OF_SUBSCRIPTION_FORMS: 'generation_of_subscription_forms',
  REQUEST_DIGITAL_PROFILE_FL: 'request_digital_profile_fl',
  REQUEST_NBKI_DATA: 'request_nbki_data',
  SENDING_ACT_TO_EDO: 'sending_act_to_edo',   //Отправка акта в ЭДО
  SENDING_DOCUMENTS_TO_EDO: 'sending_documents_to_edo',
  RENAMING_APPLICATION_FILES: 'renaming_application_files',
  EDITING_A_DOCUMENT_TYPE: 'editing_a_document_type',
};
